<p-toast></p-toast>
<p-blockUI [blocked]="isLoading">
    <div class="fixed top-0 left-0 w-full h-full flex align-items-center justify-content-center z-5 block-ui-overlay">
        <i class="pi pi-spinner pi-spin block-ui-spinner"></i>
    </div>
</p-blockUI>
<div [formGroup]="educationInfoForm" class="education-container">

    <div formArrayName="entries">

        <div *ngFor="let entry of entries.controls; let i = index" [formGroupName]="i" class="education-card mb-4 p-4">

            <div class="education-card-title-row">
                <span class="education-card-title">Add Education</span>
                <button *ngIf="entries.controls.length > 1" pButton type="button" icon="pi pi-trash" 
                    class="p-button-danger p-button-text p-button-sm" (click)="removeEntry(i)">
                </button>
            </div>

            <div class="form-group full-width mb-3">
                <label class="field-label">SELECT EDUCATION Level <span class="req">*</span></label>
                <p-dropdown [options]="getAvailableLevelOptions(i)" formControlName="level" styleClass="w-full"
                    placeholder="Select level" [showClear]="true"
                    [ngClass]="{'ng-invalid ng-touched': entry.get('level')?.invalid && entry.get('level')?.touched}">
                </p-dropdown>
                <small *ngIf="entry.get('level')?.invalid && entry.get('level')?.touched" class="error-msg">Please
                    select an education level</small>
            </div>
            
            <ng-container *ngIf="entry.get('level')?.value !== null">
               
                <!-- ===== FILE UPLOAD SECTION ===== -->
                <div class="w-full mb-3 upload-banner">
                    <span class="upload-banner-text">Upload your {{
                        getLevelLabel(entry.get('level')?.value) }} Transcript to autofill this page&nbsp;</span>
                    <div class="flex align-items-center">
                        <p-fileUpload class="file-upload-button1" *ngIf="!hasFiles(i)" mode="basic"
                            chooseLabel="Upload file" chooseIcon="pi pi-upload" [auto]="true"
                            (onSelect)="onFileUpload($event, i)" styleClass="file-upload-btn"
                            [disabled]="parseJobData[i].status === 'parsing'">
                        </p-fileUpload>
                        <div *ngIf="hasFiles(i)" class="uploaded-file-pill flex align-items-center gap-2">
                            <i class="pi pi-file upload-file-icon"></i>
                            <span class="uploaded-file-name cursor-pointer"
                                (click)="openPreview(getUploadedFiles(i)[0])">{{ getDocumentDisplayName(i) }}</span>
                            <button pButton type="button" icon="pi pi-times"
                                class="p-button-rounded p-button-danger p-button-text uploaded-file-remove"
                                (click)="removeFileObj(i)"
                                [disabled]="parseJobData[i].status === 'parsing'"></button>
                        </div>
                    </div>
                </div>


                <small class="p-error block mt-2 mb-2" *ngIf="entry.get('document')?.hasError('required') && entry.get('document')?.touched">{{ getDocumentDisplayName(i) }} is required</small>

                <!-- ===== FORM FIELDS ===== -->
                <div class="p-fluid grid">
                    <ng-container *ngIf="entry.get('level')?.value !== EducationalLevelEnum.Bachelors && entry.get('level')?.value !== EducationalLevelEnum.Masters">
                        <div class="col-12 md:col-6 mb-1">
                            <label class="required text-xs font-bold block mb-2  "
                                style="text-transform: uppercase;">SCHOOL NAME<span
                                    class="text-red-500">*</span></label>
                            <input pInputText class="w-full" formControlName="schoolName"
                                placeholder="Enter school name"
                                [ngClass]="{'ng-invalid ng-touched': entry.get('schoolName')?.invalid && entry.get('schoolName')?.touched}" />
                            <small class="p-error block mt-1"
                                *ngIf="entry.get('schoolName')?.hasError('required') && entry.get('schoolName')?.touched">School
                                name is required</small>
                            <small class="p-error block mt-1"
                                *ngIf="entry.get('schoolName')?.hasError('pattern') && entry.get('schoolName')?.touched">Invalid
                                format, only alphabets are allowed</small>
                        </div>

                        <div class="col-12 md:col-6 mb-1">
                            <label class="required text-xs font-bold block mb-2  "
                                style="text-transform: uppercase;">LOCATION (CITY, COUNTRY) <span
                                    class="text-red-500">*</span></label>
                            <div class="flex gap-2 w-full">
                                <div class="w-6">
                                     <input pInputText class="w-full" formControlName="city" placeholder="City"
                                        [ngClass]="{'ng-invalid ng-touched': entry.get('city')?.invalid && entry.get('city')?.touched}" />
                                
                                 <small class="p-error block mt-1"
                                *ngIf="entry.get('city')?.hasError('required') && entry.get('city')?.touched">City is
                                required</small>
                                 <small class="p-error block mt-1"
                                *ngIf="entry.get('city')?.hasError('pattern') && entry.get('city')?.touched">Invalid format, only alphabets are allowed</small>
                                </div>
                            
                                <div class="w-6">
                                    <p-dropdown [options]="countryOptions" formControlName="country"
                                        placeholder="Country" [showClear]="true" [filter]="true" styleClass="w-full"
                                        [ngClass]="{'ng-invalid ng-touched': entry.get('country')?.invalid && entry.get('country')?.touched}">
                                    </p-dropdown>
                                    
                                     <small class="p-error block mt-1"
                                *ngIf="entry.get('country')?.invalid && entry.get('country')?.touched">Country is
                                required</small>
                                </div>
                            </div>
                          
                        </div>

                        <div class="col-12 md:col-6 mb-1">
                            <label class="required text-xs font-bold block mb-2  "
                                style="text-transform: uppercase;">YEARS ATTENDED <span
                                    class="text-red-500">*</span></label>
                            <div class="flex gap-2 w-full align-items-center">
                                <div class="w-6">
                                    <input pInputText type="number" class="w-full" formControlName="attendedFrom"
                                        placeholder="From"
                                        [ngClass]="{'ng-invalid ng-touched': entry.get('attendedFrom')?.hasError('required') && entry.get('attendedFrom')?.touched}" />
                                </div>
                                <span>-</span>
                                <div class="w-6">
                                    <input pInputText type="number" class="w-full" formControlName="attendedTo"
                                        placeholder="To"
                                        [ngClass]="{'ng-invalid ng-touched': entry.get('attendedTo')?.hasError('required') && entry.get('attendedTo')?.touched}" />
                                </div>
                            </div>
                            <small class="p-error block mt-1"
                                *ngIf="(entry.get('attendedFrom')?.hasError('required') && entry.get('attendedFrom')?.touched) || (entry.get('attendedTo')?.hasError('required') && entry.get('attendedTo')?.touched)">Years attended are required</small>
                            <small class="p-error block mt-1"
                                *ngIf="entry.get('attendedFrom')?.hasError('yearFuture') && entry.get('attendedFrom')?.touched">Attended from date cannot be in the future.</small>
                            <small class="p-error block mt-1"
                                *ngIf="entry.get('attendedTo')?.hasError('dateRangeInvalid') && entry.get('attendedTo')?.touched">Attended to date must be after attended from date.</small>
                        </div>

                        <div class="col-12 md:col-6 mb-1">
                            <label class="required text-xs font-bold block mb-2  "
                                style="text-transform: uppercase;">BOARD / EXAM TYPE <span
                                    class="text-red-500">*</span></label>
                            <p-dropdown [options]="boardOptions" formControlName="boardType" styleClass="w-full"
                                placeholder="e.g. CBSE, IB, A-Levels" [showClear]="true" [filter]="true"
                                [ngClass]="{'ng-invalid ng-touched': entry.get('boardType')?.invalid && entry.get('boardType')?.touched}">
                            </p-dropdown>
                            <small class="p-error block mt-1"
                                *ngIf="entry.get('boardType')?.invalid && entry.get('boardType')?.touched">Board is
                                required</small>
                        </div>

                        <div class="col-12 md:col-6 mb-1">
                            <label class="required text-xs font-bold block mb-2"
                                style="text-transform: uppercase;">SUBJECTS &amp; GRADES / SCORES <span
                                    class="text-red-500">*</span></label>

                            <div class="flex gap-2 align-items-start w-full">
                                <div class="flex-grow-1" style="width: 60%">
                                    <input pInputText class="w-full" [ngModel]="Marks[i].Subject"
                                        (ngModelChange)="Marks[i].Subject = $any($event)"
                                        [ngModelOptions]="{standalone: true}" placeholder="e.g. Math, Physics"
                                        #subjInput="ngModel" />
                                    <small class="p-error block mt-1" *ngIf="Marks[i].Subject && !alphaSpaceRegex.test(Marks[i].Subject)">Invalid format, only alphabets are allowed</small>
                                </div>
                                <div style="width: 20%">
                                    <input type="number" pInputText class="w-full" [(ngModel)]="Marks[i].Grade"
                                        [ngModelOptions]="{standalone: true}" placeholder="Score" />
                                    <small class="p-error block mt-1" *ngIf="Marks[i].Grade && !numericRegex.test(Marks[i].Grade.toString())">Invalid format, only numbers are allowed</small>
                                </div>
                                <div style="width: 20%">
                                    <button pButton type="button" icon="pi pi-plus" class="w-full subject-add-button"
                                        [disabled]="!Marks[i].Subject || !Marks[i].Grade || !alphaSpaceRegex.test(Marks[i].Subject) || !numericRegex.test(Marks[i].Grade.toString())"
                                        (click)="addSubjectGrade(i)">
                                    </button>
                                </div>
                            </div>

                            <div *ngIf="getSubjectGrades(i).length > 0" class="flex flex-wrap gap-2 mt-2">
                                <span *ngFor="let sg of getSubjectGrades(i); let sgIdx = index"
                                    class="flex align-items-center gap-1 px-3 py-1 border-round-xl font-medium text-sm"
                                    style="background: #cdde22ff">
                                    {{ sg }}
                                    <button type="button"
                                        class="bg-transparent border-none cursor-pointer p-0 ml-1 flex align-items-center border-circle hover:bg-red-100"
                                        style="color: #e41408; width: 1.5rem; height: 1.5rem; justify-content: center;"
                                        (click)="removeSubjectGrade(i, sgIdx)">
                                        <i class="pi pi-times" style="font-size: 0.7rem;"></i>
                                    </button>
                                </span>
                            </div>

                            <small class="p-error block mt-1"
                                *ngIf="entry.get('subjectsGrades')?.invalid && entry.get('subjectsGrades')?.touched">At
                                least one subject and grade is required</small>
                        </div>

                        <div class="col-12 md:col-6 mb-1">
                            <label class="required text-xs font-bold block mb-2  "
                                style="text-transform: uppercase;">GRADE / PERCENTAGE <span
                                    class="text-red-500">*</span></label>
                            <input pInputText class="w-full" formControlName="percentage" type="number"
                                placeholder="Enter score"
                                [ngClass]="{'ng-invalid ng-touched': entry.get('percentage')?.invalid && entry.get('percentage')?.touched}" />
                            <small class="p-error block mt-1"
                                *ngIf="entry.get('percentage')?.hasError('required') && entry.get('percentage')?.touched">Grade/Percentage
                                is required</small>
                            <small class="p-error block mt-1"
                                *ngIf="entry.get('percentage')?.hasError('pattern') && entry.get('percentage')?.touched">Invalid format, only numbers are allowed</small>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="entry.get('level')?.value === EducationalLevelEnum.Bachelors || entry.get('level')?.value === EducationalLevelEnum.Masters">
                        <div class="col-12 md:col-6 mb-1">
                            <label class="required text-xs font-bold block mb-2  "
                                style="text-transform: uppercase;">UNIVERSITY NAME <span
                                    class="text-red-500">*</span></label>
                            <input pInputText class="w-full" formControlName="universityName"
                                placeholder="Enter university name"
                                [ngClass]="{'ng-invalid ng-touched': entry.get('universityName')?.invalid && entry.get('universityName')?.touched}" />
                            <small class="p-error block mt-1"
                                *ngIf="entry.get('universityName')?.hasError('required') && entry.get('universityName')?.touched">University
                                name is required</small>
                            <small class="p-error block mt-1"
                                *ngIf="entry.get('universityName')?.hasError('pattern') && entry.get('universityName')?.touched">Invalid format, only alphabets are allowed</small>
                        </div>
                        <div class="col-12 md:col-6 mb-1">
                            <label class="required text-xs font-bold block mb-2  "
                                style="text-transform: uppercase;">DEGREE NAME <span
                                    class="text-red-500">*</span></label>
                            <input pInputText class="w-full" formControlName="degreeName"
                                placeholder="Enter degree title"
                                [ngClass]="{'ng-invalid ng-touched': entry.get('degreeName')?.invalid && entry.get('degreeName')?.touched}" />
                            <small class="p-error block mt-1"
                                *ngIf="entry.get('degreeName')?.hasError('required') && entry.get('degreeName')?.touched">Degree
                                name is required</small>
                            <small class="p-error block mt-1"
                                *ngIf="entry.get('degreeName')?.hasError('pattern') && entry.get('degreeName')?.touched">Invalid format, only alphabets are allowed</small>
                        </div>
                        <div class="col-12 md:col-6 mb-1">
                            <label class="required text-xs font-bold block mb-2  "
                                style="text-transform: uppercase;">LOCATION (CITY, COUNTRY) <span
                                    class="text-red-500">*</span></label>
                            <div class="flex gap-2 w-full">
                                <div class="w-6">
                                    <input pInputText class="w-full" formControlName="city" placeholder="City"
                                        [ngClass]="{'ng-invalid ng-touched': entry.get('city')?.invalid && entry.get('city')?.touched}" />
                                    <small class="p-error block mt-1"
                                        *ngIf="entry.get('city')?.hasError('required') && entry.get('city')?.touched">City is required</small>
                                    <small class="p-error block mt-1"
                                        *ngIf="entry.get('city')?.hasError('pattern') && entry.get('city')?.touched">Invalid format, only alphabets are allowed</small>
                                </div>
                                <div class="w-6">
                                    <p-dropdown [options]="countryOptions" formControlName="country"
                                        placeholder="Country" [showClear]="true" [filter]="true" styleClass="w-full"
                                        [ngClass]="{'ng-invalid ng-touched': entry.get('country')?.invalid && entry.get('country')?.touched}">
                                    </p-dropdown>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 md:col-6 mb-1">
                            <label class="required text-xs font-bold block mb-2  "
                                style="text-transform: uppercase;">YEARS ATTENDED <span
                                    class="text-red-500">*</span></label>
                            <div class="flex gap-2 w-full align-items-center">
                                <div class="w-5">
                                    <input pInputText type="number" class="w-full" formControlName="attendedFrom"
                                        placeholder="From"
                                        [ngClass]="{'ng-invalid ng-touched': entry.get('attendedFrom')?.hasError('required') && entry.get('attendedFrom')?.touched}" />
                                </div>
                                <span>-</span>
                                <div class="w-5 flex-grow-1">
                                    <input pInputText type="number" class="w-full" formControlName="attendedTo"
                                        placeholder="To"
                                        [ngClass]="{'ng-invalid ng-touched': entry.get('attendedTo')?.hasError('required') && entry.get('attendedTo')?.touched}" />
                                </div>
                            </div>
                            <small class="p-error block mt-1"
                                *ngIf="(entry.get('attendedFrom')?.hasError('required') && entry.get('attendedFrom')?.touched) || (entry.get('attendedTo')?.hasError('required') && entry.get('attendedTo')?.touched)">Years attended are required</small>
                            <small class="p-error block mt-1"
                                *ngIf="entry.get('attendedFrom')?.hasError('yearFuture') && entry.get('attendedFrom')?.touched">Attended from date cannot be in the future.</small>
                            <small class="p-error block mt-1"
                                *ngIf="entry.get('attendedTo')?.hasError('dateRangeInvalid') && entry.get('attendedTo')?.touched">Attended to date must be after attended from date.</small>
                        </div>
                        <div class="col-12 md:col-6 mb-1">
                            <label class="required text-xs font-bold block mb-2  "
                                style="text-transform: uppercase;">MAJORS <span class="text-red-500">*</span></label>
                            <input pInputText class="w-full" formControlName="majors" placeholder="Enter major subjects"
                                [ngClass]="{'ng-invalid ng-touched': entry.get('majors')?.invalid && entry.get('majors')?.touched}" />
                            <small class="p-error block mt-1"
                                *ngIf="entry.get('majors')?.hasError('required') && entry.get('majors')?.touched">Majors are required</small>
                            <small class="p-error block mt-1"
                                *ngIf="entry.get('majors')?.hasError('pattern') && entry.get('majors')?.touched">Invalid format, only alphabets are allowed</small>
                        </div>
                    </ng-container>
                </div>

            </ng-container>
            
            <div *ngIf="entry.get('level')?.value !== null" class="flex flex-column align-items-end mt-3 gap-1">
                <button pButton type="button" [label]="(Marks[i] && Marks[i].id) ? 'Update' : 'Save'"
                    [icon]="(Marks[i] && Marks[i].saving) ? 'pi pi-check' : 'pi pi-check'"
                    [disabled]="Marks[i].saving"
                    class="p-button-sm p-button-primary border-round-lg font-semibold px-4 save-button"
                    (click)="saveEntry(i)">
                </button>
                <p class="text-xs text-red-500 m-0 p-0" *ngIf="entry.dirty && entry.get('level')?.value !== null">
                    You have unsaved changes. Please click {{ (Marks[i] && Marks[i].id) ? 'Update' : 'Save' }} to continue.
                </p>
            </div>
        </div>
        
       <div class="mt-3 mb-2" *ngIf="entries.length < levelOptions.length">
    <button pButton type="button" label="+ Add Another Education"
        class="add-education-btn w-full justify-content-center"
        (click)="addEntry()">
    </button>
</div>
    </div>

    <input type="file" #hiddenFileInput class="hidden-file-input" (change)="onHiddenFileChange($event)"
        accept="image/*,application/pdf">

    <p-dialog [(visible)]="displayPreviewDialog" [modal]="true" header="File Preview" [dismissableMask]="true"
        [style]="{width: 'auto', 'max-width': '90vw', 'min-width': '50vw'}">
        <div class="text-center p-4 relative preview-dialog-body" *ngIf="selectedPreviewItem">
            <div *ngIf="isPreviewLoading"
                class="absolute top-0 left-0 w-full h-full flex flex-column align-items-center justify-content-center z-2 bg-white-alpha-60">
                <i class="pi pi-spinner pi-spin text-4xl text-primary mb-3"></i>
                <span class="  font-medium font-bold">Loading preview...</span>
            </div>
            <img *ngIf="isImage(selectedPreviewItem)" [src]="selectedPreviewItem.previewUrl" class="preview-image"
                (load)="onPreviewLoad()" (error)="onPreviewLoad()">

            <iframe *ngIf="isPdf(selectedPreviewItem) && safePdfUrl" [src]="safePdfUrl" width="100%" height="600px"
                class="preview-iframe" (load)="onPreviewLoad()">
            </iframe>

            <div *ngIf="!isImage(selectedPreviewItem) && !isPdf(selectedPreviewItem)"
                class="p-5 flex flex-column align-items-center justify-content-center" style="min-width: 300px">
                <i class="pi pi-file mb-3" style="font-size: 4rem; color: #6366f1"></i>
                <h3 class="text-xl text-800 mb-3">Preview not available for this file type</h3>
                <p class="  mb-4">{{ selectedPreviewItem.name }}</p>
                <a [href]="selectedPreviewItem.previewUrl" [download]="selectedPreviewItem.name" pButton
                    label="Download to View" icon="pi pi-download" class="p-button-outlined"></a>
            </div>
        </div>
    </p-dialog>

    <p-confirmDialog [style]="{width: '450px'}" styleClass="custom-delete-dialog"></p-confirmDialog>

<!-- Document-reading modal — outside form so overlay covers full viewport -->
<app-linkdindetails-fetch
  *ngIf="isDocModalVisible"
  [isVisible]="isDocModalVisible"
  [autoComplete]="false"
  [fileName]="docModalFileName"
  [initialFields]="educationDocFields"
  (onComplete)="onDocModalComplete()"
  (onCancel)="onDocModalCancel()"
  (onClose)="onDocModalClose()">
</app-linkdindetails-fetch>
